<template>
  <md-dialog-alert
    v-if="isLoggedIn"
    :md-active.sync="timeOut"
    :md-close-on-esc="false"
    :md-click-outside-to-close="false"
    :md-title="$t('session_expired')"
    :md-content="$t('session_expired_text_label')"
    :md-confirm-text="$t('confirm')"
    @md-closed="onConfirm" />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      timeOut: false,
      confirm: false
    }
  },
  onIdle() {
    if(this.isLoggedIn){
      this.timeOutModal();
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn']),
  },
  methods: {
    timeOutModal(){
      this.timeOut = true
    },
    onConfirm(){
      this.confirm = true
      if(this.confirm){
        this.$store.dispatch('logout');
        this.$router.push({name:'Authentication'});
      }
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/SessionTimeout.vue